<template>
  <div v-if="isCoord"><ProjectsListCoord /></div>
  <div v-if="isDev"><ProjectsListDev /></div>
  <div v-if="isScrum"><ProjectsListScrum /></div>
  <div v-if="isTestador"><ProjectsListTestador /></div>
</template>

<script>
import ProjectsListCoord from '@/components/ProjectsListCoord.vue';
import ProjectsListDev from '@/components/ProjectsListDev.vue';
import ProjectsListScrum from '@/components/ProjectsListScrum.vue';
import ProjectsListTestador from '@/components/ProjectsListTestador.vue';

export default {
  components: {
    ProjectsListCoord,
    ProjectsListDev,
    ProjectsListScrum,
    ProjectsListTestador,
  },

  computed: {
    isDev() {
      return localStorage.getItem('funcao') === 'Desenvolvedor';
    },
    isCoord() {
      return localStorage.getItem('funcao') === 'Coordenador';
    },
    isScrum() {
      return localStorage.getItem('funcao') === 'Scrum Master';
    },
    isTestador() {
      return localStorage.getItem('funcao') === 'Testador';
    },
  },
};
</script>
